import { runThirdPartyBoot } from "./thirdPartyScripts";

/**
 * Third-party document stack boot (task 0055). Must stay the storefront
 * entry's FIRST import: the `SCHA.feature` host, the Kameleoon engine
 * insertion, and the GTM dataLayer initialization have to exist before any
 * other module (React tree included) reads them. `runThirdPartyBoot` runs
 * synchronously through the vendor script insertions and never blocks module
 * evaluation on network.
 */
runThirdPartyBoot();
